/**
 * Any Dealer-specific javascript can be added here.
 *
 * The OEM theme's JS is all bundled by mix, but if you need to include a
 * import a specific file, '@oem-theme' is an alias to the OEM theme's
 * 'assets/js' folder, and can be referenced like so:
 * import { convertStrToMilitaryTime } from '@oem-theme/utilities.js';
 *
 * For convenience, '@dealer' is an alias to this theme's 'assets/js' folder.
 */

import $ from 'jquery';

document.addEventListener('DOMContentLoaded', function () {

    const $homePage = $('.page-template-home');

    if ($homePage.length != 0) {

        $homePage.find('.callout-about .callout-about__links a').each(function() {
            $(this).removeClass('link');
            $(this).removeClass('link_box');
            $(this).removeClass('link_box-2');
            $(this).addClass('button btn-brand-1');
        });
    }

})